import { useState, useEffect } from "react";

const useFetch = (url) => {

    const [data, setData] = useState(null);
    const [ispending, setPending] = useState(true);
    const [erroralert,setError] = useState(null);
    const [fallBackToPdfView,setFallBack]=useState(false);


    useEffect(() => {
        const abortCont = new AbortController();
            fetch(url, {signal: abortCont.signal})
            .then(res => {
                if (!res.ok) {
                    setFallBack(true);
                    throw Error ("Could not fetch data");
                }
              
                return res.json();
            })
            .then(data => {
                setData(data)
                setPending(false)
                // setError(null)
                if (data === null) {
                    setFallBack(true);
                }
            })
            .catch(err => {
                if(err.name !== 'AbortError') {
                    setError(err.message);
                    setFallBack(true)
                    setPending(false);
                }
            });
       return () => abortCont.abort();
    }, [url]);

 return {data, ispending, fallBackToPdfView, erroralert};
}
export default useFetch;